import React, {useState, useEffect} from 'react'
import db from '../firebase'
import { Loader } from '../components/Loader'
import { Education } from '../components/Education'
import { Col, Row } from 'react-bootstrap'
import Aos from 'aos'
import 'aos/dist/aos.css'

export const QualificationScreen = () => {
    
    const [education, setEducation] = useState([])

    useEffect(()=>{
        Aos.init({})
        db.collection('education').orderBy('index','desc').get()
        .then((snapShot)=>{
            setEducation(snapShot.docs.map(doc => ({id:doc.id, educationDetails:doc.data()})))
        })
    },[])

    return <>
        {education.length===0 
        ? <Loader/>
        :
        <div style={{ margin:"5rem auto 3rem auto" }}>
            {typeof window==="object" && window.innerWidth<500 && <h3 data-aos="fade-down" className='mx-auto mobile_anime' style={{ width:"max-content" }}>Academics...</h3>}
            <Row className='pl-1 pt-5 mx-auto pr-0' style={{ width:'100%', overflowX:'hidden' }}>
            {education.map(e=>(
                <Col className='mr-2 mb-5' key={e.educationDetails.index}>
                    <Education 
                        image={e.educationDetails.image}
                        start={e.educationDetails.start}
                        end={e.educationDetails.end}
                        university={e.educationDetails.university}
                        institute={e.educationDetails.institute}
                        level={e.educationDetails.level}
                        major={e.educationDetails.major}
                        type={e.educationDetails.type}
                        current={e.educationDetails.current}
                        aggregate={e.educationDetails.aggregate}
                        address={e.educationDetails.address}
                        />
                </Col>
            ))}
            </Row>
        </div>
    }    
    </>
}
